import { render, staticRenderFns } from "./AddressForm2.vue?vue&type=template&id=6eb998c1&scoped=true"
import script from "./AddressForm2.ts?vue&type=script&lang=ts&external"
export * from "./AddressForm2.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb998c1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6eb998c1')) {
      api.createRecord('6eb998c1', component.options)
    } else {
      api.reload('6eb998c1', component.options)
    }
    module.hot.accept("./AddressForm2.vue?vue&type=template&id=6eb998c1&scoped=true", function () {
      api.rerender('6eb998c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/ProcessesForms/components/P42/AddressForm2/AddressForm2.vue"
export default component.exports